module.exports = __webpack_public_path__ + "img/banana-black.08da2c87.svg";